export default Backbone.GoogleMaps.MarkerView.extend({
  mapEvents: {
    mouseover: 'onMouseover',
    mouseout: 'onMouseout',
  },

  constructor() {
    Backbone.GoogleMaps.MarkerView.prototype.constructor.apply(this, arguments);
    this.rank = this.model.get('rank');
    this.service_type = this.model.collection.service_type;
    this.defaultZIndex = this.map.topZIndex - this.rank;

    this.gOverlay.setIcon(this.model.get('icon_off'));
    this.gOverlay.setZIndex(this.defaultZIndex);

    Rover.pubSub.on(this.markerHighlightEvent(), _.bind(this.onMarkerHighlight, this));

    Rover.pubSub.on(this.sitterShowOnMapEvent(), _.bind(this.showOnMap, this));
    Rover.pubSub.on('dilla:reveal-outsiders', _.bind(this.revealOutsiders, this));

    Rover.pubSub.on('search:hide-concealed-markers', _.bind(this.hideConcealed, this));
  },

  revealOutsiders() {
    if (this.model.get('is_concealed')) {
      this.setVisible(true, true);
    }
  },

  hideConcealed() {
    if (this.model.get('is_concealed')) {
      this.setVisible(false, true);
    }
  },

  setVisible(visible, force) {
    // Only show is_concealed markers that are forced
    if (visible && (force || !this.model.get('is_concealed'))) {
      this.gOverlay.setVisible(true);
    } else {
      this.gOverlay.setVisible(false);
    }
  },

  sitterHighlightEvent() {
    return ['sitter', 'highlight', this.service_type, this.rank].join(':');
  },

  sitterSelectedEvent() {
    return ['sitter', 'selected', this.service_type, this.rank].join(':');
  },

  sitterShowOnMapEvent() {
    return ['sitter', 'showOnMap', this.service_type, this.rank].join(':');
  },

  markerHighlightEvent() {
    return ['marker', 'highlight', this.service_type, this.rank].join(':');
  },

  showOnMap() {
    const inView =
      this.map &&
      this.map.getBounds() &&
      this.map.getBounds().contains(this.gOverlay.getPosition());

    if (!inView) {
      Rover.pubSub.trigger('map:updating');
      this.map.setCenter(this.gOverlay.getPosition());
    }
  },

  openDetail() {
    Rover.pubSub.trigger(this.sitterSelectedEvent());

    // Track the event
    const result = this.model.getSearchResult();
  },

  highlight(highlighted) {
    if (highlighted) {
      this.map.topZIndex += 1;
      this.gOverlay.setZIndex(this.map.topZIndex);
      this.gOverlay.setIcon(this.model.get('icon_on'));
    } else {
      this.gOverlay.setIcon(this.model.get('icon_off'));
    }
  },

  onMarkerHighlight(highlighted) {
    this.highlight(highlighted);
  },

  onMouseover() {
    Rover.pubSub.trigger(this.sitterHighlightEvent(), true);
    this.highlight(true);
  },

  onMouseout() {
    Rover.pubSub.trigger(this.sitterHighlightEvent(), false);
    this.highlight(false);
  },
});



// WEBPACK FOOTER //
// ./js/backbone/views/search/search_result_marker_view.js